import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PageEvent } from "@angular/material";

@Component({
  selector: "lowy-grid-paginator",
  templateUrl: "./grid-paginator.component.html",
  styleUrls: ["./grid-paginator.component.scss"],
})
export class GridPaginatorComponent {
  @Input() totalRowCount: number;
  @Input() pageSizeOptions: number[];

  @Output() page: EventEmitter<PageEvent>;

  pageIndex: number;
  pageSize: number;

  constructor() {
    this.page = new EventEmitter();

    this.pageIndex = 0;
    this.pageSize = 10;
  }

  public updatePage(action: string, $event: any) {
    switch (action) {
      case "previous":
        if (this.pageIndex > 0) {
          this.pageIndex--;
        }
        break;
      case "next":
        if (this.pageIndex < this.totalRowCount / this.pageSize) {
          this.pageIndex++;
        }
        break;
      case "pageSize":
        this.pageIndex = 0;
        break;
    }

    this.page.emit({
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      length: this.totalRowCount,
    });
  }

  public reset() {
    this.pageIndex = 0;
    this.pageSize = 10;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/grid/grid-paginator/grid-paginator.component.ts